export default function PressEnterSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -0.5 41 5"
      shapeRendering="crispEdges"
      style={{
        display: "block",
        width: 41,
      }}
    >
      <title>Press Enter</title>
      <path
        stroke="#ffffff"
        d="M0 0h3M4 0h3M8 0h3M12 0h3M16 0h3M22 0h3M26 0h2M30 0h3M34 0h3M38 0h3M0 1h1M2 1h1M4 1h1M6 1h1M8 1h1M12 1h1M16 1h1M22 1h1M26 1h1M28 1h1M31 1h1M34 1h1M38 1h1M40 1h1M0 2h3M4 2h2M8 2h3M12 2h3M16 2h3M22 2h3M26 2h1M28 2h1M31 2h1M34 2h3M38 2h2M0 3h1M4 3h1M6 3h1M8 3h1M14 3h1M18 3h1M22 3h1M26 3h1M28 3h1M31 3h1M34 3h1M38 3h1M40 3h1M0 4h1M4 4h1M6 4h1M8 4h3M12 4h3M16 4h3M22 4h3M26 4h1M28 4h1M31 4h1M34 4h3M38 4h1M40 4h1"
      />
    </svg>
  );
}
